import { Component, computed, input } from "@angular/core";

export type FooterSpacingType = 'content' | 'aside';

@Component({
    selector: 'footer-spacing',
    template: '',
    host: {
        '[class]': `classes()`
    }
})
export class FooterSpacing {

    type = input.required<FooterSpacingType>();

    classes = computed(() => {
        return this.type() === 'content' ? 'sm:h-[4.375rem] md:h-[4.875rem] xl:h-[5.375rem]' : 'lg:mb-[4.875rem] xl:mb-[5.375rem]';
    });
}